import styled from 'styled-components';

import Button from '@components/web/src/atoms/Buttons/Button';
import { COLORS } from '@components/web/src/styles';

export const ExitButton = styled(Button)`
  color: ${COLORS.base.white} !important;
`;
